import { LikeSlug } from '../services/staff-activity-api.service';

export interface ReactionDefinition {
  slug: LikeSlug;
  icon: string;
  label: string;
}

export const ACTIVITY_REACTIONS: ReactionDefinition[] = [
  { slug: 'like', icon: '👍', label: 'Like' },
  { slug: 'love', icon: '❤️', label: 'Love' },
  { slug: 'laugh', icon: '😄', label: 'Haha' },
  { slug: 'celebration', icon: '🎉', label: 'Celebrate' },
];

// Icon shown on the footer "React" button before the user has reacted.
export const DEFAULT_REACTION_ICON = 'ri-thumb-up-line';
